// extracted by mini-css-extract-plugin
export default {"colorpass":"#c8f4f4","colorfail":"#ffcece","colorpassdirect":"#62c6c4","colorfaildirect":"#e90029","chartContainerStyle":"TestResultsRecordChart_chartContainerStyle__XoSFp"};